const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, "");
export const API_URL = `${API_BASE_URL}/api`;

export const buildApiUrl = (path = "") => {
  if (!path) return API_BASE_URL;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildApiEndpoint = (path = "") => {
  if (!path) return API_URL;
  return `${API_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
